import platformConfig from '/config/platform.config';

const getFontWeightIOS = (fontWeight: any) => {
  switch (fontWeight) {
    case 'regular':
      return '400';
    case 'bold':
      return '700';
  }
};

const getFontWeightAndroid = (fontWeight: any) => {
  switch (fontWeight) {
    case 'regular':
      return 'Regular';
    case 'bold':
      return 'Bold';
  }
};

export const getFontFamily = (fontWeight: any) => {
  const os = platformConfig.getOS();

  if (os === 'ios') {
    return {
      fontFamily: 'Muli',
      fontWeight: getFontWeightIOS(fontWeight),
    };
  } else if (os === 'web') {
    // Web platform - use standard font-family with weight
    return {
      fontFamily:
        'Muli, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontWeight: fontWeight === 'bold' ? '700' : '400',
    };
  } else {
    // Android and other platforms
    const weight = getFontWeightAndroid(fontWeight);
    return {
      fontFamily: `Muli-${weight}`,
    };
  }
};

export const getInputFontFamily = () => {
  const os = platformConfig.getOS();

  if (os === 'ios') {
    // Use default font family on iOS
    return {};
  } else if (os === 'web') {
    // Web platform - use proper font family for inputs
    return {
      fontFamily:
        'Muli, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    };
  } else {
    // Android and other platforms
    return {fontFamily: 'Muli-Regular'};
  }
};

export const hasWhiteSpace = (string: any) => {
  // First potential white space does not count
  for (let i = 1; i < string.length; i++) {
    if (string[i] === ' ') {
      return true;
    }
  }
  return false;
};
